import {
  Button,
  Form,
  Input,
  Select,
  Switch,
  Modal,
  message,
  Typography,
} from 'antd';
import PropTypes from 'prop-types';
import {
  CLINIC_PAYMENT_METHOD_ENUM,
  CLINIC_PAYMENT_METHOD_OPTIONS,
} from '../../appContants';
import { forwardRef, useImperativeHandle } from 'react';

const { Text } = Typography;

const emailRules = [
  {
    type: 'email',
    message: 'Please enter a valid email',
  },
];

const ClinicLocationForm = forwardRef(function ClinicLocationForm(
  { formValues, onSubmit, loading },
  ref
) {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = Form.useForm();
  const reset = () => form?.resetFields();
  useImperativeHandle(ref, () => ({
    reset,
  }));

  return (
    <Form
      form={form}
      initialValues={formValues}
      onFinish={onSubmit}
      layout="vertical"
      clearOnDestroy
    >
      <Form.Item
        noStyle
        label="Location ID"
        name="clinicLocationId"
        rules={[{ required: true }]}
      >
        <Input disabled hidden />
      </Form.Item>
      <Form.Item
        label="Location Title"
        name="clinicLocationTitle"
        rules={[{ required: true }]}
      >
        <Input disabled />
      </Form.Item>
      <Form.Item label="Address" name="address" rules={[{ required: true }]}>
        <Input disabled />
      </Form.Item>
      <Form.Item
        label="Mobile"
        name="contactNumber"
        rules={[{ required: true }]}
      >
        <Input disabled />
      </Form.Item>
      <Form.Item label="Admin Email" name="adminEmail" rules={emailRules}>
        <Input type="email" />
      </Form.Item>
      <Form.Item label="Account Email" name="accountEmail" rules={emailRules}>
        <Input type="email" />
      </Form.Item>
      <Form.Item label="Doctor Email" name="doctorEmail" rules={emailRules}>
        <Input type="email" />
      </Form.Item>
      <Form.Item
        label="Payment Method"
        name={'paymentMethod'}
        rules={[{ required: true, message: 'Payment method required' }]}
      >
        <Select
          options={CLINIC_PAYMENT_METHOD_OPTIONS}
          components={{
            IndicatorSeparator: () => null,
          }}
          onChange={async (value) => {
            if (value === CLINIC_PAYMENT_METHOD_ENUM.PAY_AS_YOU_GO) {
              const confirmStatus = await modal.confirm({
                title: 'Alert',
                content: (
                  <Text>
                    By changing the payment method to <b>Pay As You Go</b>, a
                    new invoice will be created for any cases in the current
                    month!
                  </Text>
                ),
                okText: 'Continue',
                cancelText: 'Discard',
              });
              if (!confirmStatus) {
                form?.setFieldValue(
                  'paymentMethod',
                  CLINIC_PAYMENT_METHOD_ENUM.MONTHLY
                );
                message.success(<Text>Switched back to <b>Monthly</b> payment method!</Text>);
              }
            }
          }}
        />
      </Form.Item>
      <Form.Item label="Status" name={'status'}>
        <Switch
          checkedChildren="Active"
          unCheckedChildren="In-Active"
          defaultChecked
        />
      </Form.Item>
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
      {contextHolder}
    </Form>
  );
});
ClinicLocationForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
};
export default ClinicLocationForm;
